import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const NAV = [
  { href: "#vision", label: "Vision" },
  { href: "#how", label: "How it works" },
  { href: "#co-invest", label: "Co-Invest" },
  { href: "#own-outright", label: "Own outright" },
  { href: "#refer", label: "Refer a family" },
  { href: "#register", label: "Register" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[var(--bone)]/85 backdrop-blur-xl border-b border-[var(--border-soft)]"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] flex items-center justify-between py-4 md:py-5">
        <a
          href="#top"
          data-testid="brand-wordmark"
          onClick={scrollTo("#top")}
          className="font-serif-display text-xl md:text-[1.4rem] leading-none tracking-tight flex items-baseline gap-2"
        >
          <span className={scrolled ? "text-[var(--ink)]" : "text-[var(--bone)]"}>Co-Own</span>
          <span
            className="font-bold not-italic"
            style={{
              color: "#E87A4C",
              textShadow: scrolled ? "none" : "0 1px 14px rgba(10,17,40,0.55)",
              letterSpacing: "-0.005em",
            }}
          >
            Israel
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
              onClick={scrollTo(n.href)}
              className={`text-sm tracking-wide transition-colors hover:text-[var(--gold)] ${
                scrolled ? "text-[var(--ink)]/80" : "text-[var(--bone)]/85"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <Button
          data-testid="header-register-btn"
          onClick={scrollTo("#register")}
          className={`rounded-full px-5 md:px-6 h-10 md:h-11 text-sm font-medium tracking-wide transition-transform hover:-translate-y-0.5 ${
            scrolled
              ? "bg-[var(--ink)] text-[var(--bone)] hover:bg-[var(--ink-hover)]"
              : "bg-[var(--bone)] text-[var(--ink)] hover:bg-white"
          }`}
        >
          Register Interest
        </Button>
      </div>
    </header>
  );
}
